module.exports = __webpack_public_path__ + "static/media/marketing.0447fe12.jpg";